import React, { useState, useEffect } from 'react';
import { FileText, Calendar, Clock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export default function BillingPage() {
  const { api } = useAuth();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('get', '/api/portal/billing').then(r => setBilling(r.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-[#D4A017] border-t-transparent rounded-full animate-spin" /></div>;

  const contract = billing?.contract;

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold text-white mb-6">Facturen & Contract</h1>
      {!contract ? (
        <div className="bg-[#0f172a] rounded-2xl border border-white/5 p-8 text-center">
          <FileText className="w-12 h-12 text-[#475569] mx-auto mb-4" />
          <h3 className="text-white font-bold mb-2">Nog geen contract</h3>
          <p className="text-[#64748b]">Zodra uw contract is getekend verschijnt het hier.</p>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="bg-[#0f172a] rounded-2xl border border-[#D4A017]/20 p-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#D4A017]/10 rounded-xl flex items-center justify-center">
                <FileText className="w-6 h-6 text-[#D4A017]" />
              </div>
              <div>
                <h2 className="text-white font-bold">{contract.service}</h2>
                <span className={`text-xs px-2 py-0.5 rounded-full font-bold ${contract.status === 'active' ? 'bg-green-500/20 text-green-400' : 'bg-[#475569]/20 text-[#475569]'}`}>
                  {contract.status === 'active' ? 'Actief' : contract.status}
                </span>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                { icon: FileText, label: 'Prijs', value: `€${contract.price}/maand` },
                { icon: Calendar, label: 'Startdatum', value: contract.start_date || '-' },
                { icon: Clock, label: 'Looptijd', value: `${contract.duration} maanden` },
              ].map(({ icon: Icon, label, value }) => (
                <div key={label} className="bg-white/5 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon className="w-4 h-4 text-[#D4A017]" />
                    <span className="text-[#94a3b8] text-xs uppercase tracking-wider">{label}</span>
                  </div>
                  <p className="text-white font-semibold">{value}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-[#0f172a] rounded-2xl border border-white/5 p-6 text-center">
            <p className="text-[#64748b] text-sm">Voor vragen over uw factuur, neem contact op via <a href="mailto:info@imperiaai.nl" className="text-[#D4A017] hover:underline">info@imperiaai.nl</a> of bel <a href="tel:0382340037" className="text-[#D4A017] hover:underline">0382340037</a>.</p>
          </div>
        </div>
      )}
    </div>
  );
}
